const adaptGuide = [
    {
        head: `🔥 DOMINANT (D) Style`,
        body: `Around 🔥 be more outgoing and task-oriented.
        They value–`,
        emphasize: [
            `Efficiency: results and solutions`,
            `Opportunities: to act on their ambitions`,
            `Goals: to use their drive`,
            `Plans: strong-willed`,
            `Time: indepedent and time-conscious`,
            `Honest: bottom line and decisive`,
            `Ownership: speak their mind and act on what they think`,
        ]
    },
    {
        head: `🌻 INFLUENTIAL (I) Style`,
        body: `Around 🌻 be more outgoing and people-oriented.
        They value–`,
        emphasize: [
            `Fun: impulsive and enthusiastic`,
            `Recognition: actively rejects isolation`,
            `Trust: will talk to anyone`,
            `People: a stranger is a friend they haven't met`,
            `Lifestyle: seeks new ways of doing things`,
            `Energy & Optimism: inspiring and easygoing`,
            `Stories: they'll want to hear one after sharing theirs`,
        ]
    },
    {
        head: `🌊 COMPLIANT (C) Style`,
        body: `Around 🌊 be more reserved and task-oriented.
        They value–`,
        emphasize: [
            `Quality: "the devil's in the details"`,
            `Facts & Logic: avoiding emotional decisions`,
            `Procedure & Order: if it can be labeled, categorized or sorted, do it`,
            `Honesty & Loyalty: prefers smaller social circles`,
            `Integrity & Consistency: will read the IKEA manual`,
            `Details: no detail is too small to be noticed`,
            `Correctness: analyzes, evaluates and assesses`,
        ]
    },
    {
        head: `🌳 STEADY (S) Style`,
        body: `Around 🌳 be more reserved and people-oriented.
        They value–`,
        emphasize: [
            `Reliability & Cooperation: genuinely interested in others`,
            `Leisure: always appears unhurried and tranquil`,
            `Patience: good listeners expect this quality of others`,
            `Peace & Team-player: will feel their way to what is right`,
            `Steadiness: consistent and stable, never forgetting a birthday`,
            `Helping-hand: comes across more interested in you than themselves`,
            `Security: always 'there' and trusted by many`,
        ]
    }

]

export {adaptGuide};
